<template>
  <v-dialog
    v-model="dialog"
    :transition="false"
    :persistent="pending"
    @click:outside="!pending ? cancel() : () => {}"
    :max-width="maxWidth"
  >
    <MediaFileLoader
      :file-type="fileType"
      @files-uploaded="upload"
      @close-dialog="close"
      @update-grid="$emit('update-grid')"
    />
  </v-dialog>
</template>
<script>
import MediaFileLoader from '@/components/media-file-loader'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
export default {
  name: 'UploadDialog',
  components: {
    MediaFileLoader
  },
  props: {
    title: {
      type: String,
      default: 'Confirmation required'
    },
    description: {
      type: String,
      default: null
    },
    maxWidth: {
      type: [Number, String],
      default: 500
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    fileType: {
      type: Object,
      default: () => mediaTypesByKeys().ALL
    }
  },
  data () {
    return {
      dialog: false,
      payload: null,
      awaitCallback: false,
      awaitingCallback: false,
      resolve: () => {},
      reject: () => {}
    }
  },
  computed: {
    pending () {
      return this.awaitingCallback
    }
  },
  watch: {
    dialog (val) {
      if (!val) this.payload = null
    }
  },
  methods: {
    open (payload, awaitCallback = false) {
      this.payload = payload
      this.awaitCallback = awaitCallback
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    close () {
      this.awaitingCallback = false
      this.dialog = false
    },
    confirm () {
      if (this.awaitCallback) this.awaitingCallback = true
      this.resolve({
        payload: this.payload,
        cb: () => {
          this.close()
        }
      })
      if (!this.awaitCallback) this.close()
    },
    cancel () {
      this.reject({ cancel: true })
      this.close()
    },
    upload (files) {
      this.$emit('uploaded', files)
    }
  }
}
</script>
